import { apiPromiseTypes } from 'redux/middleware/api-promise/action-types';

export const POST = apiPromiseTypes('appleWallet', 'post');
export const HIDE_MYWAITROSE_APPLE_WALLET_ERROR =
  'waitrose/appleWallet/HIDE_MYWAITROSE_APPLE_WALLET_ERROR';
export const REMOVE_MYWAITROSE_APPLE_WALLET_ITEM =
  'waitrose/appleWallet/REMOVE_MYWAITROSE_APPLE_WALLET_ITEM';
